module.exports = __webpack_public_path__ + "img/product-banner_7.ae8ef344.png";